export const IsMobileMixin = {
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    computed: {
        isMobile() {
            return this.windowWidth <= 768; 
        }
    },
    mounted() {
        //check window size
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
}